import { useEffect, useState } from 'react';
import { Filters, useQueryState } from '@ui/src';
import { useAppDispatch } from '@store';
import { overviewCardsSchema } from '../../statements/variables/statements-cards';
import {
  getCardsTransactions,
  onFilterCardsTransactionsList,
  onSortCardsTransactionsList,
} from '../../store/slices/cards';
import { OrganizationType, CardsTransactions } from '../../types';
import { CustomerCard } from '../types';

const useCardsTranscations = ({
  customerType,
  cards,
  values,
}: {
  customerType: OrganizationType;
  cards?: CustomerCard[];
  values?: CardsTransactions[];
}) => {
  const [cardId, setCardId] = useState('');

  const dispatch = useAppDispatch();

  const { filters, sort, onSortChange, onFilterChange } =
    useQueryState(overviewCardsSchema);

  const onSort = (name: string) => {
    onSortChange(name);

    dispatch(
      onSortCardsTransactionsList({
        name,
        direction: sort.sortDir === 'asc' ? 'desc' : 'asc',
      }),
    );
  };

  const onChangeCard = (id: string) => {
    setCardId(id);

    dispatch(
      getCardsTransactions({
        cardId: id,
        customerType,
      }),
    );
  };

  const onFilter = (filterValues: Filters) => {
    const body = { ...filterValues };

    onFilterChange(filterValues);

    if (filterValues.date) {
      body.date.value = filterValues.date.value?.map((item) =>
        new Date(item).toISOString(),
      );
    }

    dispatch(onFilterCardsTransactionsList(body));
  };

  useEffect(() => {
    if (cards?.length && !cardId) {
      setCardId(cards[0].id);
    }
  }, [cards, cardId]);

  useEffect(() => {
    if (cardId && !values) {
      dispatch(
        getCardsTransactions({
          name: sort?.sortProp,
          direction: sort?.sortDir as 'asc' | 'desc',
          filters,
          cardId,
          customerType,
        }),
      );
    }
  }, [dispatch, values, cardId, sort, filters]);

  return {
    onChangeCard,
    cardId,
    onSort,
    onFilter,
    filters,
    sort,
    onFilterChange,
  };
};

export default useCardsTranscations;
